<template lang="pug"> 
  v-row(no-gutters)
    v-col.mt-3.px-1(cols='12', md='6')
      v-card.card.text-center.py-3(v-if="countdownSent != $t('closed-stake')", flat)
        h5.white--text {{ $t('closed-stake-in') }}
        h2.black--text  {{ countdownSent || $t('closed-stake')}}
      v-card.card.text-center.py-3(v-else flat)
        h5.white--text {{ $t('closed-prediction-in') }}
        h2.black--text {{ closeTime || $t('closed-stake') }}
      v-card.card.text-center.py-5.mt-3(flat)
        h5.white--text {{ $t('total') }}
        h2 {{ sumNumber }}
        v-form.mx-5(
          ref='form'
          v-model='valid'
          lazy-validation
          @submit.prevent
        )
          v-row.pt-4(no-gutters justify="center")
            v-text-field(
              v-model='randNum'
              :rules='ruleCounter'
              min='0'
              dense
              outlined
              required
              counter='5'
              type='Number'
              background-color="white"
              :placeholder="$t('placeholder.random-number')"
              class="add-input"
              @paste.prevent
              @keydown='onKeyDown'
            )
              v-btn(
                depressed
                height='40'
                @click='randomNum()'
              ) {{ $t('button.random-number') }}
          v-row(no-gutters justify="center")
            v-btn(
              type='submit'
              block
              depressed
              color="var(--bg-secondary-color)"
              class="white--text btn-add font-bold"
              :class="{'btn-add--disabled': expiredAddrand>0}"
              :disabled='expiredAddrand>0'
              @click='addRandNumber(randNum)'
            )
              div.white--text {{ $t('button.add-number') }}
              div(
                v-if='expiredAddrand>0'
              ).white--text {{ $t('get-in') }} {{ expiredAddrand }}
        h4.mt-5 {{ $t('quick-random') }}
        v-row.mx-3
          v-col.pt-2(
            v-for='(item,i) in randNumGroup'
            :key='i', cols='3'
            align="center"
          ).pa-1
            v-btn(
              depressed
              dark
              width='100%'
              color='green'
              class="num-items"
              @click='addRandNumber(item)'
            )
              h3.num-item {{ item }}
    v-col.mt-3.px-1(cols='12', md='6')
      v-simple-table(fixed-header).number-table
        template(v-slot:default)
          thead
            tr
              th.text-left
                | {{ $t('table.sequence') }}
              th.text-left
                | {{ $t('table.number') }}
              th.text-left
                | {{ $t('table.member') }}
              th.text-left(width='40%')
                | {{ $t('table.time') }}
          tbody
            tr(v-for='(item,i) in dataList', :key='i')
              td {{ i+1 }}
              td {{ item.number }}
              td {{ item.username }}
              td {{ item.created_at }}
      v-card.pb-5(v-if='dataList.length===0', flat)
        n-empty

</template>
<script>   
import { gameRooms as apiGameRooms } from '@/apis'
import { preventNumber } from '@/utils/preventkeydown.js'
import { timeRemain } from '@/plugins/time'
import * as c from '@/const/setTimeOutConfig' 
import { ROUTE_GAME_LOTTO_DETAIL } from '@/const/route'
export default { 
  props : {
    countdownSent : {
      type : String,
      default : null
    },
    closeTime : {
      type : String,
      default : null
    }, 
    closedTimestamp : {
      type : Number,
      default : 0
    }
  },
  data: () => ({
    valid : true,
    sumNumber : 0,
    randNum : '',
    randNumGroup :[],
    dataList : [],
    countdownTime : '', 
    debounce:null,
    expiredAddrand : 0 ,
    timeStampFinish : 0,
    Intervalstat : ''
  }),   

  computed : {
    ruleCounter () {
      return [value => value.toString().length>4||value.toString.length<1&&!!value || this.$t('rules.random-number')]
    },
    uid () {
      return this.$route.query.id 
    }
  },

  async created () {   
    this.timeStampFinish = localStorage.getItem('countDownAddRandomNumber')
    var timeRemain = this.timeStampFinish - Date.now()
    if(timeRemain > 0){
      this.expiredAddrand = Math.floor(timeRemain/1000)
      this.countDownTimer()
    }
    this.randomNumGroup()
    this.getHistory()
    this.Intervalstat = setInterval(()=>this.updateHistory(),10000)
  },
  beforeDestroy () {
    clearInterval(this.Intervalstat) 
  },
  methods : {   
    onKeyDown (evt) {  
      preventNumber(evt)  
      if(this.randNum.length>=5 && evt.keyCode !==8 ){ 
        evt.preventDefault()
        return
      } 
    },

    countDownTimer () {   
      if(this.expiredAddrand > 0) { 
        setTimeout(() => {
          this.expiredAddrand -= 1 
          this.countDownTimer()
        }, c.COUNTDOWNONESEC)
      }
    },

    updateHistory () {    
      if(this.$route.name === ROUTE_GAME_LOTTO_DETAIL && timeRemain(this.closedTimestamp)>0 ){ 
        this.getHistory() 
      }  
    },

    async getHistory () {
      const [err, data,] = await apiGameRooms.getResult(this.uid)
      
      if(err){
        this.$alert('',err,'warning') 
        return
      }
    
      this.sumNumber = data.summary
      this.dataList = data.player 
    },

    async addRandNumber (number) {
      number = number.toString()

      this.randNum = number

      this.$refs.form.validate() 

      clearTimeout(this.debounce)

      this.debounce = setTimeout(async ()=>{
        if(number.length===5&&this.expiredAddrand===0){ 

          this.$ga.event('Button', 'AddRandomNumber', 'AddNumberPage', '')

          this.randomNumGroup()

          let params = {
            number : number
          }
          
          if(number.toString().length===5){
          const [err, , message] = await apiGameRooms.postAddResult(this.uid,params)
           
          if(err){
            this.$alert('',err,'warning') 
            return
          }
            
          localStorage.setItem('countDownAddRandomNumber',Date.now()+10000) 
          this.expiredAddrand=10
          this.countDownTimer ()
          this.$refs.form.resetValidation()
          this.randNum='' 
          this.getHistory()
          this.$alert('',message,'success')  
          }
        } 
      },c.DEBOUNCBUTTON)
    },

    randomNum () {
      this.$ga.event('Button', 'RandomNumber', 'AddNumberPage', '')
      var x = Math.floor(Math.random() * 90000)+10000;
      this.randNum = x.toString()
    },
    randomNumGroup () {
      this.randNumGroup=[]
      for(var temp = 0 ;temp<12;temp++){
        var x = Math.floor(Math.random() * 90000)+10000;
        this.randNumGroup.push(x)
      } 
    }
  }, 
}
</script> 
<style scoped>
.card {
  background: radial-gradient(ellipse at center top,  var(--bg-secondary-color-v2), var(--bg-secondary-color-v2), var(--bg-secondary-color-v2));
  border-radius: .5rem;
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, .1), 0 4px 6px -4px rgba(0, 0, 0, .1) !important;
  height: auto;
}

.btn-add {
  --tw-text-opacity: 1 !important;
  background: radial-gradient(ellipse at center top, #383838, #171717) !important;
  color: rgb(255 255 255 / 1) !important;
}

.btn-add--disabled {
  opacity: .5;
}

.num-items {
  border-style: solid;
  border-color: rgba(0, 0, 0, 1) !important;
  border-width: 1px 1px 2px;
  background: radial-gradient(ellipse at center top, #fff, #fff);
}

.num-item {
  color: #000;
}

.add-input >>> .v-text-field__details {
  color: rgba(255, 255, 255, 0.7) !important;
}

.add-input >>> .v-messages__message {
  color: rgba(255, 255, 255, 0.7) !important;
}

.add-input >>> fieldset {
  border-color: black !important;
}

.number-table {
  background-color: unset;
}

.number-table >>> .v-data-table__wrapper {
  border-radius: .5rem;
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, .1), 0 4px 6px -4px rgba(0, 0, 0, .1) !important;
  background: unset;
  background-color: unset;
}

th {
  --tw-bg-opacity: 1;
  background-color: rgba(46, 30, 30, 1) !important;
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity)) !important;
  --tw-shadow: inset 0 -1px hsla(0, 0%, 100%, .1);
  --tw-shadow-colored: inset 0 -1px var(--tw-shadow-color);
}

tr:nth-child(2n) {
  background-color: var(--bg-primary-250);
}
</style>